import { DatePipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, ConfirmEventType, PrimeTemplate } from 'primeng/api';
import { parse } from 'url';
import { BookingInfoProperties, BookingPassengerInfoProperties } from '../Models/BookingPassengerTicketIssuanceProperties';
import { Countries } from '../Models/Countries';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { FormsModule } from '@angular/forms';
import { Bind } from 'primeng/bind';
import { Select } from 'primeng/select';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
@Component({
    selector: 'app-airblue-modify',
    templateUrl: './airblue-modify.component.html',
    styleUrls: ['./airblue-modify.component.css'],
    providers: [ConfirmationService, MessageService],
    imports: [FormsModule, NgClass, Bind, Select, PrimeTemplate, Toast, ConfirmDialog]
})

/** ModifyPassengerInfo component*/
export class AirblueModifyComponent {
  /** ModifyPassengerInfo ctor */
  bookingInfo = new BookingInfoProperties();
  dataFormSubmit: boolean = false;
  @Input()
  pattern: string | RegExp;
  countryList: Countries[] | undefined;
  date;
  dob: boolean[] = [false];
  constructor( private router: Router, public psService: PassengerInfoService, private confirmationService: ConfirmationService, private messageService: MessageService, public userService: PassengerInfoService) {

  }
  ngOnInit() {
    this.bookingInfo = JSON.parse(localStorage.getItem("flightmodifyPassengerInfo"));
    //this.bookingInfo = new BookingInfoProperties();
    //let bookingpass = new BookingPassengerInfoProperties();
    //bookingpass.firstName = "Shoaib";

    //this.bookingInfo.bookingPassengerInfoProperties.push(bookingpass);
    for (let o = 0; o < this.bookingInfo.bookingPassengerInfoProperties.length; o++) {
      const originalDate: Date = new Date(this.bookingInfo.bookingPassengerInfoProperties[o].paxdob);
      this.bookingInfo.bookingPassengerInfoProperties[o].dob = originalDate.toISOString().split('T')[0];
      const originalDates: Date = new Date(this.bookingInfo.bookingPassengerInfoProperties[o].passportValidTo);
      this.bookingInfo.bookingPassengerInfoProperties[o].psdatevalid = originalDates.toISOString().split('T')[0];
      //this.bookingInfo.bookingPassengerInfoProperties[o].paxdob= new Date(this.bookingInfo.bookingPassengerInfoProperties[o].paxdob);
      //this.bookingInfo.bookingPassengerInfoProperties[o].passportValidTo = new Date(this.bookingInfo.bookingPassengerInfoProperties[o].passportValidTo);
    }

    this.getCountries();
    this.date = new Date().toISOString().slice(0, 10);
  }


  validateDobForPassengerType(i): boolean {
    // Calculate the current date
    if (this.bookingInfo.bookingPassengerInfoProperties[i].dob == undefined || this.bookingInfo.bookingPassengerInfoProperties[i].dob == null) {
      return;
    }
    this.bookingInfo.bookingPassengerInfoProperties[i].paxdob = new Date(this.bookingInfo.bookingPassengerInfoProperties[i].dob);
    const currentDate = new Date();
    let minDob: Date;
    let maxDob: Date;
    this.bookingInfo.bookingPassengerInfoProperties[i].passengerType = 1;
    if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType === 1) {
      minDob = new Date(currentDate.getFullYear() - 12, currentDate.getMonth(), currentDate.getDate());
    } else if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType === 2) {
      minDob = new Date(currentDate.getFullYear() - 11, currentDate.getMonth(), currentDate.getDate());
      maxDob = new Date(currentDate.getFullYear() - 2, currentDate.getMonth(), currentDate.getDate());
    } else if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType === 3) {
      minDob = new Date(currentDate.getFullYear() - 2, currentDate.getMonth(), currentDate.getDate());
      maxDob = currentDate;
    }
    let dob = new Date(this.bookingInfo.bookingPassengerInfoProperties[i].paxdob);
    if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType === 1) {
      if ((dob <= minDob)) {
        document.getElementById(`dobvalidate${i}`).innerHTML = '';

        return true;
      }
      else {
        document.getElementById(`dobvalidate${i}`).innerHTML = 'Adult ages greater than 11';
        return false;
      }
    }
    if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType === 2) {
      if ((dob > minDob && dob < maxDob)) {

        document.getElementById(`dobvalidate${i}`).innerHTML = '';
        return true;
       }
       else {
        document.getElementById(`dobvalidate${i}`).innerHTML = 'Child ages between 2 and 11';
        return false;
       }
      }
       if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType === 3) {
         if ((dob < minDob)) {

           document.getElementById(`dobvalidate${i}`).innerHTML = '';
           return true;
         }
         else {
           document.getElementById(`dobvalidate${i}`).innerHTML = 'Infant under age 2';
           return false;
         }
      }
    
    
   
    // Compare the date of birth with the calculated range
  }

  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  modifyBooking: boolean = false;
  Confirm(obj:any) {

    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if (!this.SubmitData(obj)) {
          return false;
        }
    
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
                    case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Now You Edit the Passenger Info' });
      break;
  
    }
  }
});
  }
  cancel() {
    this.confirmationService.confirm({
      message: 'Do you want to Cancel this Modification?',
      header: 'Cancel Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Modification cancelled' });
        this.router.navigateByUrl('/ticket-issuance');
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
                    case ConfirmEventType.REJECT:
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Now You Edit the Passenger Info' });
      break;
      
    }
  }
});
  }
  passengerSelected: boolean = false;

  selectPassenger() {
    let check = false;
    for (let o = 0; o < this.bookingInfo.bookingPassengerInfoProperties.length; o++) {
      if (this.bookingInfo.bookingPassengerInfoProperties[o].isChecked) {
        check = true;
        break;
      }

    }
    if (check) {
      this.passengerSelected = true;
    }
    else {
      this.messageService.add({ severity: 'info', summary: '', detail: 'Select The Passenger' });
    }

  }
  SubmitData(obj: any): boolean {
    this.dataFormSubmit = true;
    if (obj.invalid) {
      return false;
    }
    for (let o = 0; o < this.bookingInfo.bookingPassengerInfoProperties.length; o++) {
      if (this.bookingInfo.bookingPassengerInfoProperties[o].isChecked) {
        if (!this.validateDobForPassengerType(o)) {
          return false;
        }
        this.bookingInfo.bookingPassengerInfoProperties[o].passportValidTo = new Date(this.bookingInfo.bookingPassengerInfoProperties[o].psdatevalid);
      }
    }
   
    this.modifyBooking = true;
    this.psService.modifyBookingPassengerInfoRecord(this.bookingInfo).subscribe((data) => {
      if (data.isSaved) {
        this.modifyBooking = false;
        this.router.navigateByUrl('/ticket-issuance');
      }
      else {
        this.modifyBooking = false;
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Please Try Again Later' });
      }
    })

  }
}
